<template>
    <div class="block tests" v-if="turniket">
        <div class="tests-header">
            <h3 class="tests-header-title">
                Відгуки
                <div class="tests-header-labels">
                    <button class="tests-header-btn" :class="{active: activetab === 'grouped'}" @click="activetab = 'grouped'">
                        За організаціями ({{ groupedTests.length }})
                    </button>
                    <button class="tests-header-btn" :class="{active: activetab === 'all'}" @click="activetab = 'all'">
                        Всі відгуки ({{ allTests.length }})
                    </button>
                </div>
            </h3>
        </div>
        <div class="tests-content">
            <div v-if="turniket.tests && turniket.tests.length">
                <div class="table">
                    <div class="table-head table-row">
                        <div class="table-cell date-cell">Дата</div>
                        <div class="table-cell status-cell">Статус</div>
                        <div class="table-cell author-cell">Перевірив</div>
                        <div class="table-cell comments-cell">Коментарі</div>
                        <div class="table-cell conclusion-cell">Висновок</div>
                    </div>
                    <TestItem :test="item" :is-mobile=isMobile v-for="(item, index) in this.activetab === 'grouped' ? groupedTests : allTests" :key="index"
                              :style="{'z-index': turniket.tests.length - index}" :childTests="item.experts.length ? getChildTests(item.id, item.experts[0].user_id, item.id) : false"
                              :set-open="anchorTestId === item.id"
                              @opencslider="showSlider" @rendershare="showShareModal = true" @updatelikes="updateTestReactions"/>
                </div>
                <TestItemCarousel v-if="sliderPhotos.length" :slides="sliderPhotos" :start="sliderStart" :is-mobile=isMobile
                                  @closeslider="hideSlider"/>
            </div>
            <div v-else class="no-test-block">
                <div class="no-test" v-if="turniket.status.name === 'Сертифікований'">
                    Турнікет {{ turniket.name }} сертифікований організацією
                    <AuthorTooltip :info="item.organization" :position="{center: !isMobile}" :isSert="true" v-for="( item, index ) in turniket.certificates" :key="index">
                        <img :src="item.organization.photo" :alt="item.organization.name"
                                          class="no-test-org-img" width="20" height="20" v-if="!noImage" @error="noImage = true">
                        <IconImage v-else class="no-test-image"/>{{ item.organization.name }}
                    </AuthorTooltip>
                    та не потребує тестування
                </div>
                <div v-else class="no-test">
                    Турнікет {{ turniket.name }}  ще ніким не тестувався. Тому ми не можемо його рекомендувати
                </div>
            </div>
        </div>
        <TestShare v-if="showShareModal" @closeshare="showShareModal = false"/>
        <TestCommentRemove/>
        <RecallReviewModal v-if="store.recallModalShow" @recall="removeTest"/>
        <FlagsSprite/>
    </div>
</template>

<script>
import TestItem from "./TestItem";
import {fetchUrl} from "../../consts";
import TestItemCarousel from './TestItemCarousel';
import IconImage from '../icons/IconImage';
import IconDisLike from '../icons/IconDisLike';
import IconLike from '../icons/IconLike';
import AuthorTooltip from '../AuthorTooltip';
import FlagsSprite from '../icons/FlagsSprite';
import TestShare from './parts/TestShare';
import {commonPageData} from '../../common';
import TestCommentRemove from './parts/TestCommentRemove.vue';
import {tourniquetStore} from '../../store/store';
import RecallReviewModal from "./RecallReviewModal.vue";

export default {
    name: "TurniketPage",
    props: ['turniketId', 'csrfToken', 'userData', 'userCanComment'],
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    data() {
        return {
            turniket: null,
            activetab: 'grouped',
            showGroupedTests: false,
            sliderPhotos: [],
            sliderStart: 0,
            isMobile: null,
            noImage: false,
            showShareModal: false,
            anchorTestId: parseInt(window.location.hash.replace('#', ''))
        }
    },
    mounted() {
        this.store.setUserCommentStatus(this.userCanComment);
        this.store.setCsrfToken(this.csrfToken);
        if(this.userData) {
            this.store.setUser(this.userData);
        };
        fetch(`${fetchUrl}api/v1/turnikets/` + this.turniketId).then(response => response.json())
            .then(data => {
                this.turniket = data.data;
                commonPageData.tourniquetData = data.data;
            }).then(() => {
                if (this.anchorTestId && this.allTests.findIndex(item => item.id === this.anchorTestId) !== -1) {
                    if (this.groupedTests.findIndex(item => item.id === this.anchorTestId) === -1) {
                        this.activetab = 'all';
                    }
                    setTimeout(() => {
                        const testPosition = `#test-${this.anchorTestId}`;
                        this.scrollToAnchorSection(testPosition);
                    }, 300)
                }
        });
    },
    created() {
        this.getIsMobile();
        window.addEventListener("resize", this.getIsMobile);
    },
    destroyed() {
        window.removeEventListener("resize", this.getIsMobile);
    },
    methods: {
        removeTest(id) {
            this.turniket.tests = this.turniket.tests.filter(item => item.id !== id);
        },
        updateTestReactions(data) {
            const testIndex = this.turniket.tests.findIndex(item => item.id === data.testId);
            if(testIndex !== -1) {
                this.turniket.tests[testIndex].vote_good = data.testLikes;
                this.turniket.tests[testIndex].vote_bad = data.testDislikes;
            }
        },
        scrollToAnchorSection(id, duration = 400) {
            const section = document.querySelector(id);
            if (section) {
                const eTop = section.getBoundingClientRect().bottom - section.offsetHeight - 60;
                let eAmt = window.scrollY;
                let curTime = 0;

                while (curTime <= duration) {
                    window.setTimeout(this.scrollPage, curTime, eAmt);
                    curTime += duration / 100;
                    eAmt += eTop / 100;
                }
            }
        },
        scrollPage(yPos) {
            window.scrollTo(0, yPos);
        },
        showSlider(photos, start) {
            this.sliderPhotos = photos;
            this.sliderStart = start
        },
        hideSlider() {
            this.sliderPhotos = [];
        },
        getIsMobile() {
            this.isMobile = window.innerWidth < 766;
        },
        getChildTests(id, userId, currentTest) {
            return this.activetab === 'grouped' ? this.allTests.filter(item => item.id !== currentTest && (item.parent_id === id || (item.experts && item.experts.length && item.experts[0]?.user_id === userId))).sort((a, b) => b.id - a.id) : false
        }
    },
    computed: {
        groupedTests() {
            return this.turniket.tests.filter(item => !item.parent_id)
        },
        allTests() {
            return this.turniket.tests
        }
    },
    components: {
        RecallReviewModal,
        TestCommentRemove,
        TestShare,
        FlagsSprite,
        AuthorTooltip,
        IconLike,
        IconDisLike,
        IconImage,
        TestItemCarousel,
        TestItem
    },
}
</script>
<style lang="scss" scoped>
@import "../../../../sass/front/helpers";

.tests {
    &-header {
        padding: 24px 36px;
        border-bottom: solid 2px #f8f8f8;

        @include responsive-below($sm) {
            background-color: #fff;
            border-radius: 8px;
            border-bottom: 0;
            margin-bottom: 2px;
            padding: 20px;
        }

        &-title {
            font-size: 28px;
            display: flex;
            align-items: center;

            @include responsive-below($sm) {
                font-size: 22px;
            }

            @include responsive-below($xs) {
                flex-direction: column;
                align-items: flex-start;
            }
        }

        &-labels {
            margin-left: 10px;
            display: flex;
            gap: 5px;
            background: #F8F8F8;
            border: 1px solid #FFFFFF;
            border-radius: 12px;
            padding: 4px;

            @include responsive-below($xs) {
                margin-left: 0;
                width: 100%;
                margin-top: 10px;
            }
        }

        &-btn {
            border-radius: 8px;
            color: #252525;
            background-color: transparent;
            border: 0;
            padding: 4px 10px 8px;
            font-family: 'Ukraine';
            font-size: 12px;
            cursor: pointer;

            @include responsive-below($xs) {
                width: 50%;
            }

            &.active {
                background-color: #4578EB;
                color: #fff;
            }
        }
    }

    &-content {
        padding: 24px 36px;

        @include responsive-below($sm) {
            padding: 0;
        }
    }
}

@include responsive-below($sm) {
    .tests {
        background: transparent;
    }
}


.no-test {
    text-align: center;
    max-width: 500px;
    margin: 60px auto;
    font-weight: 500;
    color: #000;
    font-size: 18px;

    @include responsive-below($sm){
        margin: 0 auto;
        padding: 50px 20px 30px;
    }

    &-block {
        @include responsive-below($sm){
            border-radius: 8px;
            background-color: #fff;
            padding: 10px;
        }
    }

    &-org {
        color: #000;
        white-space: nowrap;

        &-img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: -2px;
            margin-right: 5px;
        }

        &:hover {
            text-decoration: underline;
        }
    }

    &-image {
        width: 20px;
        height: 20px;
        display: inline-block;
        vertical-align: -2px;
    }
}
</style>

